import React from 'react';
import { useTranslation } from 'react-i18next';
import {
	fetchActualLandUses,
	fetchCadastralMunicipalities,
	fetchDedicatedLandUses,
	fetchIllegalWasteDumpsPage,
	fetchMunicipalities,
	fetchOwnershipTypes,
} from '../../../state/api/illegalWasteDumpsAPI';
import { dateToString } from '@result/result-ui-components/src/utils/DateUtils';
import fractionUtils from '../../../utils/fractionUtils';
import unitString from '../../../utils/unitUtil';
import wasteDumpTypes from '../../../model/wasteDumpTypes';
import { fetchWasteCategoriesList } from '../../../state/api/wasteCategoriesAPI';
import IllegalDumpingLocationsTable from "../../widget/IllegalDumpingLocationsTable";

const IllegalWasteDumpsList = () => {
	const { t } = useTranslation();
	const wasteDumpOptions = wasteDumpTypes();

	return (
		<>
			<IllegalDumpingLocationsTable
				showCreateButton={true}
				selector={(state) => state.illegalWasteDumpsAPI.list}
				fetchAction={fetchIllegalWasteDumpsPage}
				columns={[
					{ name: t('id'), id: 'id',
						cellComponent: (entry) => (
						<div className="has-text-centered">{`${entry.id}${entry.externalId == null ? '' : ` (${entry.externalId})`}`}</div>
						)},
					{
						name: t('status'),
						id: 'status',
						cellComponent: (entry) => (
							<div className={`tag badge is-${entry?.status}`}>
								{t('waste_dump_type_options.' + entry.status)}
							</div>
						),
					},
					{ name: t('insert_by'), id: 'insertBy' },
					{
						name: t('municipality'),
						id: 'municipality',
						cellComponent: (entry) => <>{entry?.municipality?.name}</>,
					},
					{
						name: t('cadastral_municipality'),
						id: 'cadastralMunicipality',
						cellComponent: (entry) => <>{entry?.cadastralMunicipality?.name}</>,
					},
					{
						name: t('insert_at'),
						id: 'insertAt',
						cellComponent: (entry) => (
							<div>{dateToString(entry.insertAt, true, true)}</div>
						),
					},
					{
						name: t('area'),
						id: 'area',
						cellComponent: (entry) => (
							<>{unitString('area', entry.area || 0)}</>
						),
					},
					{
						name: t('volume'),
						id: 'volume',
						cellComponent: (entry) => (
							<>{unitString('volume', entry.volume || 0)}</>
						),
					},
					{
						name: t('waste_types'),
						id: 'wasteTypes',
						disableSort: true,
						cellComponent: (entry) => (
							<div>
								{entry?.wasteTypes
									?.map(
										(entry) =>
											`${
												entry?.fraction ? fractionUtils(entry?.fraction) : '/'
											} - ${entry?.type?.nameInternal?.toLowerCase()}`
									)
									.join(', ')}
							</div>
						),
					},
				]}
				filterColumns={[
					{
						id: 'status',
						type: 'select',
						name: t('status'),
						options: wasteDumpOptions,
					},
					{
						name: t('municipality'),
						type: 'inputtag',
						id: 'municipality.name',
						selector: [(state) => state.illegalWasteDumpsAPI.municipalities],
						fetchAction: [fetchMunicipalities],
						valueType: 'object',
					},
					{
						name: t('cadastral_municipality'),
						type: 'inputtag',
						id: 'cadastralMunicipality.name',
						selector: [
							(state) => state.illegalWasteDumpsAPI.cadastralMunicipalities,
						],
						fetchAction: [fetchCadastralMunicipalities],
						valueType: 'object',
					},
					{
						name: t('waste_type'),
						type: 'inputtag',
						id: 'wasteTypes.type.nameInternal',
						selector: [(state) => state.wasteCategoriesAPI.categories],
						fetchAction: [fetchWasteCategoriesList],
						valueType: 'object',
						filter: 'EQ',
						filterKey: 'code',
						displayKey: 'name',
						searchKey: 'nameInternal',
					},
					{
						id: 'insertAt',
						type: 'date',
						name: 'insert_at',
					},
					{
						name: t('ownership_type'),
						type: 'inputtag',
						id: 'ownershipTypes.name',
						selector: [(state) => state.illegalWasteDumpsAPI.ownershipTypes],
						fetchAction: [fetchOwnershipTypes],
						valueType: 'object',
					},
					{
						name: t('actual_land_use'),
						type: 'inputtag',
						id: 'actualLandUses.name',
						selector: [(state) => state.illegalWasteDumpsAPI.actualLandUses],
						fetchAction: [fetchActualLandUses],
						valueType: 'object',
					},
					{
						name: t('dedicated_land_use'),
						type: 'inputtag',
						id: 'dedicatedLandUses.name',
						selector: [(state) => state.illegalWasteDumpsAPI.dedicatedLandUses],
						fetchAction: [fetchDedicatedLandUses],
						valueType: 'object',
					},
				]}
			/>
		</>
	);
};

export default IllegalWasteDumpsList;
